// import React from 'react';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faTwitter, faFacebook, faLinkedin, faInstagram } from '@fortawesome/free-brands-svg-icons';
// import 'owl.carousel/dist/assets/owl.carousel.css';
// import 'owl.carousel/dist/assets/owl.theme.default.css';
// import OwlCarousel from 'react-owl-carousel';

// // Import images
// import img1 from '../img/team/1.png';
// import img2 from '../img/team/2.png';
// import img3 from '../img/team/3.png';
// import img4 from '../img/team/4.png';
// import img5 from '../img/team/5.png';

// const OurLeadership = () => {
//   const teamMembers = [
//     {
//       name: 'C Chandra Sekhar Reddy',
//       jobTitle: 'CEO & Founder',
//       imgSrc: img1,
//     },
//     {
//       name: 'Asha Jyothi G',
//       jobTitle: 'Chief Client Relations Officer',
//       imgSrc: img2,
//     },
//     {
//       name: 'Kiran Kumar M',
//       jobTitle: 'Marketing Manager',
//       imgSrc: img3,
//     },
//     {
//       name: 'Eswar Raju K',
//       jobTitle: 'SA Manager',
//       imgSrc: img4,
//     },
//     {
//       name: 'Priti Pragyan B',
//       jobTitle: 'ITE Manager',
//       imgSrc: img5,
//     },
//   ];

//   return (
//     <section className="no-bottom" aria-label="team">
//       <div className="container-fluid">
//         <div className='container'>
//         <div className=" row" style={{ paddingBottom: '30px' }}>
//         <div className="container">
//               <div className="section-title fl-wrap" style={{ textAlign: 'center',marginBottom:"-30px" }}>
//                 <h2 >Our LEADERSHIP</h2>
//               </div>
//             </div>

//           <div className="col-12 centered ">
//             <div className="detailcontent text-center p-0">
//               {/* <div className="subheading">OUR PROFESSIONALS</div> */}
//               {/* <div className="heading">Meet Our Team</div> */}
//             </div>
//           </div>
//           <div className="col-12 p-0">
//             <OwlCarousel className="owl-theme" loop margin={10} nav>
//               {teamMembers.map((member, index) => (
//                 <div className="item" key={index}>
//                   <div className="listteam">
//                     <div className="bgimg">
//                       <img src={member.imgSrc} alt={member.name} />
//                     </div>
//                     <div className="detail">
//                       <div className="listdetail">
//                         <div className="name">{member.name}</div>
//                         <div className="jobtitle">{member.jobTitle}</div>
//                         <div className="s-social">
//                           <a href="#"><FontAwesomeIcon icon={faTwitter} /></a>
//                           <a href="#"><FontAwesomeIcon icon={faFacebook} /></a>
//                           <a href="#"><FontAwesomeIcon icon={faLinkedin} /></a>
//                           <a href="#"><FontAwesomeIcon icon={faInstagram} /></a>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               ))}
//             </OwlCarousel>
//           </div>
//         </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default OurLeadership;
import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTwitter, faFacebook, faLinkedin, faInstagram } from '@fortawesome/free-brands-svg-icons';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import OwlCarousel from 'react-owl-carousel';

// Import images
import img1 from '../img/team/1.png';
import img2 from '../img/team/2.png';
import img3 from '../img/team/3.png';
import img4 from '../img/team/4.png';
import img5 from '../img/team/5.png';

const OurLeadership = () => {
  const [isHovered, setIsHovered] = useState(false);
  const teamMembers = [
    {
      name: 'C Chandra Sekhar Reddy',
      jobTitle: 'CEO & Founder',
      imgSrc: img1,
    },
    {
      name: 'Asha Jyothi G',
      jobTitle: 'Chief Client Relations Officer',
      imgSrc: img2,
    },
    {
      name: 'Kiran Kumar M',
      jobTitle: 'Marketing Manager',
      imgSrc: img3,
    },
    {
      name: 'Eswar Raju K',
      jobTitle: 'SA Manager',
      imgSrc: img4,
    },
    {
      name: 'Priti Pragyan B',
      jobTitle: 'ITE Manager',
      imgSrc: img5,
    },
  ];

  const teamCardStyle = {
    position: 'relative',
    overflow: 'hidden',
    // borderRadius: '10px',
    boxShadow: '0 6px 20px rgba(0, 0, 0, 0.5)', // Stronger, darker shadow
    background: '#fff',
    border: '1px solid black', // Adding solid black border
    transition: 'transform 0.3s ease-in-out',
  };

  const teamImageStyle = {
    position: 'relative',
    overflow: 'hidden',
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    transition: 'transform 0.3s ease-in-out',
  };

  const teamImageHoverStyle = {
    transform: 'translateY(-10px) scale(1.1)', // Move image upwards and increase its size on hover
    transition: 'transform 0.3s ease-in-out', // Smooth transition for the effect
  };



  const teamDetailsStyle = {
    padding: '20px',
    textAlign: 'center',
  };

  const teamNameStyle = {
    fontSize: '18px',
    fontWeight: 'bold',
    marginBottom: '10px',
  };

  const teamJobTitleStyle = {
    fontSize: '14px',
    color: '#777',
    marginBottom: '15px',
  };

  const socialLinksStyle = {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '10px',
  };

  const socialLinkStyle = {
    margin: '0 8px',
    fontSize: '18px',
    color: '#333',
    transition: 'color 0.3s ease',
  };

  const socialLinkHoverStyle = {
    color: '#007bff', // Change this to your desired color
  };

  return (
    <section className="no-bottom" aria-label="team">
      <div className="container-fluid">
        <div className="container" style={{ textAlign: 'center' }}>
          <div className="row" style={{ paddingBottom: '30px' }}>
            <div className="container">
              <div className="heading" style={{ fontSize: '48px', fontWeight: '700', color: 'rgb(16 16 14);' }}>
                Our <span style={{ color: '#f7941d', }}>Leadership</span>
              </div>
            </div>

            <div className="col-12 centered">
              <div className="detailcontent text-center p-0">
                {/* Optional additional text can go here */}
              </div>
            </div>

            <div className="col-12 p-0">
              <OwlCarousel
                className="owl-theme"
                loop
                margin={10}
                nav
                responsive={{
                  0: {
                    items: 1, // Show 1 card on mobile
                  },
                  600: {
                    items: 2, // Show 2 cards on tablets
                  },
                  1000: {
                    items: 3, // Show 3 cards on desktops
                  },
                }}
              >
                {teamMembers.map((member, index) => (
                  <div className="item" key={index}>
                    <div className="team-card" style={teamCardStyle}>
                      <div className="team-image" style={teamImageStyle}>
                        <img src={member.imgSrc} alt={member.name} />
                      </div>

                      <div className="team-details" style={teamDetailsStyle}>
                        <div className="team-name" style={teamNameStyle}>{member.name}</div>
                        <div className="team-jobtitle" style={teamJobTitleStyle}>{member.jobTitle}</div>
                        <div className="social-links" style={socialLinksStyle}>
                          <a href="#" style={socialLinkStyle}>
                            <FontAwesomeIcon icon={faTwitter} />
                          </a>
                          <a href="#" style={socialLinkStyle}>
                            <FontAwesomeIcon icon={faFacebook} />
                          </a>
                          <a href="#" style={socialLinkStyle}>
                            <FontAwesomeIcon icon={faLinkedin} />
                          </a>
                          <a href="#" style={socialLinkStyle}>
                            <FontAwesomeIcon icon={faInstagram} />
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </OwlCarousel>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OurLeadership;


